/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "@/views/DashboardView";
import UsersView from "@/views/users/UsersView";
import ClientsView from "@/views/clients/ClientsView";
import TokensView from "@/views/TokensView";
import SessionsView from "@/views/SessionsView";
import ActivationCodeView from "@/views/ActivationCodeView";
import ScopesView from "@/views/scopes/ScopesView";
import ClaimsView from "@/views/claims/ClaimsView";
import EditUserView from "@/views/users/EditUserView";
import PlainRouterView from "@/components/PlainRouterView";
import EditClientView from "@/views/clients/EditClientView";
import CreateClientView from "@/views/clients/CreateClientView";
import CreateUserView from "@/views/users/CreateUserView";
import CreateScopeView from "@/views/scopes/CreateScopeView";
import EditScopeView from "@/views/scopes/EditScopeView";
import CreateClaimView from "@/views/claims/CreateClaimView";
import EditClaimView from "@/views/claims/EditClaimView";
import { useAuthStore } from "@/stores/auth";

const routes = [
  {
    path: "/",
    name: "dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/authentication",
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/users",
    component: PlainRouterView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: "users",
        path: "",
        component: UsersView
      },
      {
        path: "create",
        component: CreateUserView
      },
      {
        path: ":id",
        component: EditUserView,
        props: true
      }
    ]
  }, {
    path: "/clients",
    component: PlainRouterView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: "clients",
        path: "",
        component: ClientsView
      },
      {
        path: "create",
        component: CreateClientView
      },
      {
        path: ":id",
        component: EditClientView,
        props: true
      }
    ]
  }, {
    path: "/scopes",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: "scopes",
        path: "",
        component: ScopesView
      },
      {
        name: "create",
        path: "create",
        component: CreateScopeView
      },
      {
        path: ":id",
        component: EditScopeView,
        props: true
      }
    ]
  }, {
    path: "/claims",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: "claims",
        path: "",
        component: ClaimsView
      },
      {
        name: "create",
        path: "create",
        component: CreateClaimView
      },
      {
        path: ":id",
        component: EditClaimView,
        props: true
      }
    ]
  }, {
    path: "/tokens",
    name: "tokens",
    component: TokensView,
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/sessions",
    name: "sessions",
    component: SessionsView,
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/codes",
    name: "codes",
    component: ActivationCodeView,
    meta: {
      requiresAuth: true
    }
  }, {
    path: "/auth/callback",
    component: () => {
    }
  }
];

const router = createRouter({
  history: createWebHistory(`/dashboard`),
  routes
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  if (to.path === "/auth/callback") {
    const authorization_code = to.query.code;

    await authStore.authCallback(authorization_code).then(() => {
      next("/");
    }).catch(() => {
      next({
        path: "error"
      });
    });

    return;
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!authStore.isAuthenticated) {
      location.href = authStore.getLoginUrl;
      return;
    }
  }

  next();
});

export default router;